import $ from 'jquery';

const sorting = () => {
  const $form = $('.c-blog-sorting');
  const $selector = $('.filter-by, .sort-by');

  $selector.change(() => {
    $form.submit();
  });
};
export default sorting;



// WEBPACK FOOTER //
// ./src/scripts/modules/sorting.js